/**
 * WOM Video API - Uses category param like old API
 * Base: https://api.thewordofmouth.in/api/video/videos/inhanssv1
 * Fetches with ?category=reel_video | awards_video | youtube_video | styling_video | company_videos
 */
(function() {
  'use strict';

  var CACHE_PREFIX = 'womVideoApiCache_';

  function getApiUrl() {
    return (window.vesselsWOMConfig && window.vesselsWOMConfig.videoApiUrl)
      ? window.vesselsWOMConfig.videoApiUrl
      : 'https://api.thewordofmouth.in/api/video/videos/inhanssv1';
  }

  function getCategoryUrl(category) {
    var base = getApiUrl();
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + 'category=' + encodeURIComponent(category);
  }

  async function fetchByCategory(category) {
    var cacheKey = CACHE_PREFIX + category;
    if (window[cacheKey]) return window[cacheKey];
    var url = getCategoryUrl(category);
    var promise = fetch(url, { headers: { 'ngrok-skip-browser-warning': 'true' } })
      .then(function(r) {
        if (!r.ok) throw new Error('API error: ' + r.status);
        return r.json();
      })
      .then(function(data) {
        window[cacheKey] = data;
        return data;
      });
    window[cacheKey + '_promise'] = promise;
    return promise;
  }

  async function fetchCombinedData() {
    return fetchByCategory('company_videos');
  }

  /**
   * Get videos by category - fetches with ?category=X (same as old API)
   * @param {string} category - reel_video | awards_video | youtube_video | styling_video | company_videos
   * @returns {Promise<Array>}
   */
  async function getVideosByCategory(category) {
    var data = await fetchByCategory(category);
    var items = (data && data[category]) ? data[category] : [];
    return Array.isArray(items) ? items : [];
  }

  /**
   * Get product videos - uses product_id param
   */
  async function getProductVideos(productHandle) {
    var data = await fetchCombinedData();
    var pv = (data && data.product_videos) ? data.product_videos : {};
    var arr = pv[productHandle];
    return Array.isArray(arr) ? arr : [];
  }

  window.womVideoApi = {
    getData: fetchCombinedData,
    getVideosByCategory: getVideosByCategory,
    getProductVideos: getProductVideos,
    getApiUrl: getApiUrl,
    getCategoryUrl: getCategoryUrl
  };
})();
